import React, { useContext, useState, useEffect } from 'react';
import Switch from 'react-switch';
import Loader from '../Loader';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { ReactComponent as RemoveCard } from '../../assets/img/remove.svg';
import { ReactComponent as CardChip } from '../../assets/img/card-chip.svg';
import { ReactComponent as User } from '../../assets/img/user-regular-filled.svg';
import visa from '../../assets/img/finance-payments/visa.svg';
import mastercard from '../../assets/img/finance-payments/mastercard.svg';
import dinersclub from '../../assets/img/finance-payments/diners-club.svg';
import discover from '../../assets/img/finance-payments/discover.svg';
import americanexpress from '../../assets/img/finance-payments/american-express.svg';
import jcb from '../../assets/img/finance-payments/jcb.svg';
import paypal from '../../assets/img/paypal-icon.svg';
import applepay from '../../assets/img/apple-pay-icon-gray.svg';
import '../../assets/styles/edit-payment.sass';

const EditPayment = () => {
  const context = useContext(BookerContext);
  const {
    state,
    updateStep,
    updatePreviousStep,
    updateEditor,
    updatePayment,
    updatePaymentMethodId,
    updateApplePayPaymentMethod,
    updatePayPalPaymentMethod,
    updatePaymentListId,
    updateOneTimePaymentId,
  } = context;
  const {
    paymentMethodId,
    editor: { payment: { type, brand = '', last4, id: cardId, default: checked } = {} } = {},
    previousStep,
  } = state || {};
  const { setUpdatePaymentsMenu, getPayments, togglePopup } = useContext(BookerShortContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isDefault, setIsDefault] = useState(checked);
  const popupKey = 'removePayment';

  const paymentBrand = type === 'credit_card' ? brand : type;
  const brandLowered = `${paymentBrand?.toLowerCase()?.replace(/[\s|_]/g, '')}`;
  const getFullName = type => {
    switch (type) {
      case 'apple_pay':
        return 'Apple Pay';
      case 'paypal':
        return 'PayPal';
      default:
        return `${last4}`;
    }
  };
  const fullName = getFullName(type);
  const logoList = { visa, mastercard, dinersclub, discover, americanexpress, jcb, paypal, applepay };

  useEffect(() => {
    setIsDefault(checked);
  }, [cardId, checked]);

  const onChange = () => {
    if (checked) return;

    setIsDefault(true);
    setUpdatePaymentsMenu(true);
  };

  const onDefaultChangeHandler = () => {
    if (checked) return;

    return FetchService.getWebApiResource(urlService.setAsDefaultPaymentMethod(cardId))
      .then(response => {
        console.log('response ', response);
        onChange();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {});
  };

  const removePayment = () => {
    if (!cardId) return;

    togglePopup(false, popupKey);
    setIsLoading(true);
    return FetchService.getWebApiResource(urlService.removePaymentMethod(cardId))
      .then(response => {
        updateStep(previousStep);
        updatePreviousStep('');
        updateEditor('');
        if (paymentMethodId === cardId) {
          updatePaymentMethodId(null);
          updatePayment('');
          getPayments(true);
          if (brandLowered === 'paypal' || brandLowered !== 'applepay') {
            updatePaymentListId(null);
            updateOneTimePaymentId(null);
          }
        }
        if (brandLowered === 'paypal') {
          updatePayPalPaymentMethod(null);
        }
        if (brandLowered !== 'applepay') {
          updateApplePayPaymentMethod(null);
        }
        setUpdatePaymentsMenu(true);
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const removePaymentHandler = () => {
    if (!cardId) return;

    const removePaymentBtn = [
      {
        isSecondary: true,
        textBtn: 'No',
      },
      {
        clickHandler: removePayment,
        textBtn: 'Yes',
        card: `${brandLowered !== 'paypal' && brandLowered !== 'applepay' ? `${brand} *` : ''}${fullName}`,
      },
    ];
    togglePopup(true, popupKey, removePaymentBtn);
  };

  return (
    <div className="form-group-container">
      <div className="title">Edit Payment</div>
      <div className="credit-card-container">
        <CardChip />
        <div className="credit-card-digits">
          {brandLowered !== 'paypal' && brandLowered !== 'applepay' && (
            <>
              <span className="credit-card-asteriks fas fa-asterisk" />
              <span className="credit-card-asteriks fas fa-asterisk" />
              <span className="credit-card-asteriks fas fa-asterisk" />
            </>
          )}
          <span className="credit-card-last4">{fullName}</span>
        </div>
        <div
          className="credit-card-logo"
          data-logo={brandLowered}
          style={{ backgroundImage: `url(${logoList[brandLowered]})` }}
        />
      </div>
      <div
        className={`credit-card-set-as-default-container ${isDefault ? 'disabled' : ''}`}
        {...(!isDefault && { onClick: onDefaultChangeHandler })}
      >
        <User />
        <div className="credit-card-set-as-default-value">Set as Personal Default Payment</div>
        <Switch
          onChange={onChange}
          checked={isDefault}
          className="credit-card-set-as-default-switch"
          onColor="#a4ddcc"
          onHandleColor="#0f8560"
          handleDiameter={20}
          uncheckedIcon={false}
          checkedIcon={false}
          disabled={checked}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0)"
          height={10}
          width={30}
        />
      </div>
      <div className="credit-card-remove-container" onClick={removePaymentHandler}>
        <RemoveCard />
        <div className="credit-card-remove-value">Delete Payment Method</div>
      </div>
      <Loader loading={isLoading} />
    </div>
  );
};

export default EditPayment;
